import { render, staticRenderFns } from "./GeneralSettingCloudinaryPreset.vue?vue&type=template&id=7cdf3685&"
import script from "./GeneralSettingCloudinaryPreset.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingCloudinaryPreset.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports